import { Typography } from '@persona-id/design-tokens';
import { css, DefaultTheme, FlattenInterpolation, ThemeProps } from 'styled-components';

export type DisplaySize = 'lg' | 'md' | 'sm';

export const fontFamilyMixin = css`
  font-family: ${({ theme }) => theme.text.fontFamily.base};
`;

export const displayMixins: Record<DisplaySize, FlattenInterpolation<ThemeProps<DefaultTheme>>> = {
  lg: css`
    ${Typography.DisplayLarge};
    margin: 0;
  `,
  md: css`
    ${Typography.DisplayMedium};
    margin: 0;
  `,
  sm: css`
    ${Typography.DisplaySmall};
    margin: 0;
  `,
};

export type HeadingSize = 'lg' | 'md' | 'sm';

export const headingMixins: Record<HeadingSize, FlattenInterpolation<ThemeProps<DefaultTheme>>> = {
  lg: css`
    ${Typography.HeadingLarge};
    margin: 0;
  `,
  md: css`
    ${Typography.HeadingMedium};
    margin: 0;
  `,
  sm: css`
    ${Typography.HeadingSmall};
    margin: 0;
  `,
};

export type ParagraphMixinSize =
  | 'lg'
  | 'lgBold'
  | 'lgLight'
  | 'md'
  | 'mdBold'
  | 'mdLight'
  | 'mdLink'
  | 'sm'
  | 'smLink'
  | 'xs';

export type ParagraphSize = 'lg' | 'md' | 'sm' | 'xs';

export const paragraphMixins: Record<
  ParagraphMixinSize,
  FlattenInterpolation<ThemeProps<DefaultTheme>>
> = {
  lg: css`
    ${Typography.TextLarge};
    margin: 0;
  `,
  lgBold: css`
    ${Typography.TextLargeBold};
    margin: 0;
  `,
  lgLight: css`
    ${Typography.TextLargeLight};
    margin: 0;
  `,
  md: css`
    ${Typography.TextMedium};
    margin: 0;
  `,
  mdBold: css`
    ${Typography.TextMediumBold};
    margin: 0;
  `,
  mdLight: css`
    ${Typography.TextMediumLight};
    margin: 0;
  `,
  mdLink: css`
    ${Typography.TextMediumLink};
    margin: 0;
  `,
  sm: css`
    ${Typography.TextSmall};
    margin: 0;
  `,
  smLink: css`
    ${Typography.TextSmallLink};
    margin: 0;
  `,
  xs: css`
    ${Typography.TextExtraSmall};
    margin: 0;
  `,
};
